export default __webpack_public_path__ + "static/media/menu-07-sender-ids-w.29ce4b42.svg";